import { Directive, ViewChild } from '@angular/core';
import { IIdentifiable } from 'src/app/models/interfaces/identifiable.interface';
import { NotificationService } from 'src/app/services/notification-service';
import { FormMode } from '../common/form-mode';
import { ICopyable } from '../common/icopyable';
import { DefaultListComponent } from '../list/default-list/default-list.component';
import { DefaultDetailContext } from './default-detail-context';

enum DisplayMode {
    List,
    Form,
}

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class DefaultManagementComponent<ModelInterface extends IIdentifiable, Model extends ICopyable<Model>, IdType> {
    /**
     * Liste des enums utilisés dans le template
     */
    public FormMode = FormMode;
    public DisplayMode = DisplayMode;

    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public displayMode = DisplayMode.List;

    /**
     * Contexte du formulaire.
     */
    public context: DefaultDetailContext<ModelInterface, IdType> = null;

    //DefaultListComponent<T extends ICopyable<T>>

    /**
     * Reference au composant listant les éléments.
     */
    @ViewChild('itemsList')
    protected itemsList: DefaultListComponent<Model>;

    constructor(protected notificationService: NotificationService) {}

    /**
     * Définit le mode d'affichage du formulaire (consultation / edition / création).
     * @param mode Mode d'affichage
     */
    public setDisplayMode(mode: DisplayMode) {
        this.displayMode = mode;
    }

    /**
     * Rafraichi la page.
     * @param model : Valeur de l'élément retourné par le formulaire.
     * @param mode : Mode d'affichage.
     */
    protected refresh(model: ModelInterface, mode: FormMode): void {
        this.itemsList.refresh();
        this.displayForm(model, mode);
        this.fillForm(model);
    }

    /**
     * Rafraichi la page et affiche une notification.
     * @param model : Valeur de l'élément retourné par le formulaire.
     * @param notificationString: Texte de la notification.
     * @param mode : Mode d'affichage.
     */
    protected refreshWithNotification(model: ModelInterface, notificationString: string, mode: FormMode): void {
        this.refresh(model, mode);
        this.notificationService.displaySuccess(null, notificationString);
        this.setDisplayMode(DisplayMode.Form);
    }

    /**
     * Affiche le formulaire.
     */
    protected displayForm(model: ModelInterface, formMode: FormMode): void {
        let context = this.fillForm(model);
        context.formContext.formVisible = true;
        context.formMode = formMode;

        this.context = context;

        this.setDisplayMode(DisplayMode.Form);
    }

    /**
     * Pré-rempli les champs du formulaire.
     * @param model : Valeur utilisée pour pré-remplir les champs du formulaire.
     */
    protected abstract fillForm(model: ModelInterface): DefaultDetailContext<ModelInterface, IdType>;
}
